module.exports = __webpack_public_path__ + "assets/2d-to-3d-b7673f6958b2e24fa93c73061d0e2d2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/data/images/2d-to-3d.png
// module id = 500
// module chunks = 1